module.exports = __webpack_public_path__ + "img/1-1704.a9dbf98c.png";